import * as React from "react";
import Modal from "../../ui/modal/Modal";
import {OnSuccessData} from "../../../store/action/actionHelpers";
import IndividualContact from "../../../model/contact/IndividualContact";
import AddContactForm from "../form/create/AddContactForm";
import {Option} from "ts-option";
import * as moment from "moment";

const mixpanel = require("mixpanel-browser");

interface Props {
	/**
	 * On successfully added individual contact action.
	 */
	onSuccessIndividual: OnSuccessData<IndividualContact>;
	/**
	 * On close action.
	 */
	onClose: () => void;
	/**
	 * String to use as initial data for the form.
	 */
	prePopulatedString?: Option<string>;
}

/**
 * Create contact modal view.
 */
export default class CreateContactModal extends React.PureComponent<Props, {}> {
	entryTime: moment.Moment;

	constructor(props: Props) {
		super(props);
		this.handleCloseModal = this.handleCloseModal.bind(this);
		this.handleOnSuccessIndividual = this.handleOnSuccessIndividual.bind(this);
	}

	componentDidMount() {
		this.entryTime = moment();
	}

	render() {
		return (
			<Modal onCloseClicked={this.handleCloseModal} title={"Create new contact"}>
				<AddContactForm onSuccessIndividual={this.handleOnSuccessIndividual}
								onCancel={this.handleCloseModal}
								prePopulatedString={this.props.prePopulatedString}/>
			</Modal>
		);
	}

	/**
	 * Handle close modal.
	 */
	private handleCloseModal() {
		const mxData = {
			'Contact creation duration': moment.duration(moment().diff(this.entryTime)).asSeconds(),
			'Result': 'Abandoned'
		};
		mixpanel.track("Contact creation", mxData);
		this.props.onClose();
	}

	/**
	 * Handle successfully created individual contact action.
	 */
	private handleOnSuccessIndividual(contact: IndividualContact) {
		const mxData = {
			'Contact creation duration': moment.duration(moment().diff(this.entryTime)).asSeconds(),
			'Result': 'Succeed'
		};
		mixpanel.track("Contact creation", mxData);
		this.props.onSuccessIndividual(contact);
	}
}